import { useEffect } from "react"

import useSlugExtractor from "@hooks/useSlugExtractor"
import useUser from "@hooks/useUser"

import { BILLS_ROUTES } from "@routes/bills"

import { VendorCreditsFeatureGateProps } from "./VendorCreditsFeatureGate.types"

// The flag gates screens only: Django still serves these pages, so with the feature off the page itself turns the
// visitor back to Bills rather than render anything.
export default function VendorCreditsFeatureGate(props: VendorCreditsFeatureGateProps) {
    const { children } = props

    const { user, isLoading } = useUser()
    const [billsListRoute] = useSlugExtractor([BILLS_ROUTES.LIST])

    const hasVendorCreditsFeature = !!user?.service_company?.feature_vendor_credits_enabled

    useEffect(() => {
        if (!isLoading && !hasVendorCreditsFeature) {
            window.location.replace(billsListRoute)
        }
    }, [isLoading, hasVendorCreditsFeature, billsListRoute])

    return hasVendorCreditsFeature ? children : null
}
